import { createContext, Dispatch } from 'react'
import { OrgProviderAction, OrgProviderState } from './types'

export const OrgProviderContext = createContext<{
    state: OrgProviderState
    dispatch: Dispatch<OrgProviderAction>
}>(null!)
